/* Testimonials carousel behaviour.
   One instance per `[data-testimonials-carousel]` section. Reads its config from
   data attributes so this file stays static and multi-instance safe. Owns three
   concerns: autoplay authority, in-view video playback, and the one-card drag
   clamp. */
(function () {
  var MOBILE_QUERY = '(max-width: 989px)';
  // How far (as a share of one card) the finger must travel to commit to the
  // next card; below this the drag snaps back to where it started.
  var DRAG_STEP_FRACTION = 0.2;

  function initCarousel(sectionEl) {
    if (!sectionEl || sectionEl.__testimonialsCarouselInit) return;
    var splideRoot = sectionEl.querySelector('.testimonials-carousel__splide');
    if (!splideRoot || !splideRoot.id) return; // nothing to drive (e.g. fewer than 2 slides)
    sectionEl.__testimonialsCarouselInit = true;

    var id = splideRoot.id;
    // Autoplay defaults ON; only an explicit "false" attribute turns it off.
    var DESKTOP_ON = sectionEl.getAttribute('data-autoplay-desktop') !== 'false';
    var MOBILE_ON = sectionEl.getAttribute('data-autoplay-mobile') !== 'false';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMq = window.matchMedia(MOBILE_QUERY);

    function globallyPaused() {
      return document.body.classList.contains('animations-paused');
    }

    function instance() {
      return window.slideshows && window.slideshows[id];
    }

    function shouldPlay() {
      if (reduce.matches || globallyPaused()) return false;
      return mobileMq.matches ? MOBILE_ON : DESKTOP_ON;
    }

    // Single authority for autoplay: plays/pauses based on the desktop & mobile
    // on/off settings and the current viewport, while still honoring
    // reduced-motion and the site-wide ADA pause toggle.
    function sync() {
      var inst = instance();
      if (!inst || !inst.Components || !inst.Components.Autoplay) return false;
      try {
        if (shouldPlay()) {
          inst.Components.Autoplay.play();
        } else {
          inst.Components.Autoplay.pause();
        }
      } catch (e) {}
      return true;
    }

    // Video cards. The <video> tags carry no autoplay attribute — playback is
    // driven from here so only on-screen clips run (Splide's loop clones mean
    // the same clip can exist several times over) and so reduced-motion and the
    // site-wide pause toggle are honored.
    var observer = null;

    function videosAllowed() {
      return !reduce.matches && !globallyPaused();
    }

    function onIntersect(entries) {
      for (var i = 0; i < entries.length; i++) {
        var video = entries[i].target;
        if (entries[i].isIntersecting && videosAllowed()) {
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        } else {
          video.pause();
        }
      }
    }

    function refreshVideos() {
      var root = document.getElementById(id);
      if (!root || !window.IntersectionObserver) return;

      var videos = root.querySelectorAll('video.testimonials-carousel__video');
      if (!videos.length) return;

      if (observer) observer.disconnect();
      observer = new IntersectionObserver(onIntersect, { threshold: 0.25 });

      for (var i = 0; i < videos.length; i++) {
        videos[i].pause();
        observer.observe(videos[i]);
      }
    }

    function syncAll() {
      sync();
      refreshVideos();
    }

    // Drag clamp: one swipe advances at most one card (or snaps back), instead
    // of Splide's default distance-proportional jump. On release Splide funnels
    // through Controller.go(toDest(velocity)) — a far, multi-card index. We wrap
    // Controller.go and swap that argument for a single-step '>' / '<' BEFORE
    // Move animates, so the track only ever slides to the neighbouring card (no
    // fly-out-then-snap-back overshoot). Only real pointer/touch drags are
    // touched: autoplay and dot-clicks never emit Splide's `drag` event, so they
    // fall straight through untouched.
    function installDragClamp(inst) {
      var C = inst.Components && inst.Components.Controller;
      if (!C || C.go.__tcClamped) return; // guard double-wrap on section re-render

      var root = document.getElementById(id);
      if (!root) return;

      // Direction is read from the finger's screen X, NOT the track transform:
      // in loop mode Splide silently repositions the transform among clones
      // mid-drag near the seam, which corrupts a position-delta reading at
      // exactly the wrap boundaries. Screen coordinates never reposition.
      var rtl = getComputedStyle(root).direction === 'rtl';
      var startX = null;
      var lastX = null;

      root.addEventListener('mousedown', function (e) { startX = lastX = e.clientX; }, true);
      window.addEventListener('mousemove', function (e) { lastX = e.clientX; }, true);
      root.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) { startX = lastX = e.touches[0].clientX; }
      }, true);
      window.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) { lastX = e.touches[0].clientX; }
      }, true);

      var dragging = false;
      var startIndex = 0;

      // `drag` fires once per gesture, only after Splide's own drag threshold is
      // crossed — so this flag is set for real pointer/touch drags only, never
      // for autoplay or dot-clicks.
      inst.on('drag', function () {
        dragging = true;
        startIndex = inst.index;
      });

      // Safety net so the flag can never leak to a later programmatic call. Runs
      // on a microtask — i.e. AFTER the synchronous release-go where the clamp
      // actually fires — so it never pre-empts the clamp.
      inst.on('dragged', function () {
        if (window.queueMicrotask) {
          queueMicrotask(function () { dragging = false; });
        } else {
          setTimeout(function () { dragging = false; }, 0);
        }
      });

      var origGo = C.go;
      function clampedGo(control) {
        if (dragging) {
          dragging = false;
          var net = (startX !== null && lastX !== null) ? (lastX - startX) : 0;
          var slide = root.querySelector('.testimonials-carousel__slide');
          var threshold = slide ? slide.getBoundingClientRect().width * DRAG_STEP_FRACTION : 40;
          if (Math.abs(net) < threshold) {
            return origGo.call(C, startIndex); // under threshold — snap back to origin
          }
          // Forward = finger toward the leading edge (left in LTR, right in RTL).
          // '>' / '<' step natively through the loop, wrapping at the boundaries.
          var forward = rtl ? net > 0 : net < 0;
          return origGo.call(C, forward ? '>' : '<');
        }
        return origGo.apply(C, arguments); // autoplay, dot-clicks, programmatic — untouched
      }
      clampedGo.__tcClamped = true;
      C.go = clampedGo;
    }

    var tries = 0;
    var poll = setInterval(function () {
      // Wait for Splide to mount before wiring up videos / the drag clamp — its
      // loop clones don't exist in the DOM until then, and the clones need
      // observing too. installDragClamp is idempotent (guards double-wrap).
      var inst = instance();
      if (inst) installDragClamp(inst);
      if (sync()) {
        refreshVideos();
        clearInterval(poll);
      } else if (++tries > 60) {
        refreshVideos();
        clearInterval(poll);
      }
    }, 100);

    document.body.addEventListener('animations:playing', syncAll);
    document.body.addEventListener('animations:paused', syncAll);
    if (reduce.addEventListener) reduce.addEventListener('change', syncAll);
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', sync);
  }

  function boot() {
    var sections = document.querySelectorAll('[data-testimonials-carousel]');
    for (var i = 0; i < sections.length; i++) initCarousel(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: the section DOM is replaced on edit, so re-init the new node.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    if (el.matches && el.matches('[data-testimonials-carousel]')) {
      initCarousel(el);
      return;
    }
    var inner = el.querySelector('[data-testimonials-carousel]');
    if (inner) initCarousel(inner);
  });
})();
